import React from 'react';

export default function ReceiptNotFoundIcon({ color }) {
  return (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4375 10.9658H42.1841V45.5738L39.0908 42.9071L35.9975 45.5738L32.9041 42.9071L29.8108 45.5738L26.7175 42.9071L23.6242 45.5738L20.5308 42.9071L17.4375 45.5738V10.9658Z"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M43.4609 48.8447L51.2772 58.0138"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M38.5553 50.6107C43.3418 50.6107 47.222 46.7305 47.222 41.944C47.222 37.1575 43.3418 33.2773 38.5553 33.2773C33.7689 33.2773 29.8887 37.1575 29.8887 41.944C29.8887 46.7305 33.7689 50.6107 38.5553 50.6107Z"
        fill="white"
        stroke={color}
        strokeWidth="1.2"
      />
      <rect
        x="35.9141"
        y="38.4561"
        width="8.66667"
        height="1.2"
        transform="rotate(45 35.9141 38.4561)"
        fill={color}
      />
      <rect
        x="35.0684"
        y="44.584"
        width="8.66667"
        height="1.2"
        transform="rotate(-45 35.0684 44.584)"
        fill={color}
      />
      <rect x="21.3535" y="22.8076" width="16.4348" height="1.2" fill={color} />
      <rect x="21.3535" y="26.8633" width="16.4348" height="1.2" fill={color} />
      <rect x="21.3535" y="16.3936" width="8.18235" height="1.2" fill={color} />
    </svg>
  );
}
